export async function getErrorMessage(
  response: Response,
  fallback = "Request failed",
) {
  try {
    const payload = await response.json();
    if (payload?.message) {
      if (Array.isArray(payload.message)) {
        return payload.message.join(", ");
      }
      return String(payload.message);
    }
  } catch {
    // Ignore JSON parsing errors.
  }

  return response.statusText || fallback;
}
